import type { IMasterDataRawRetailerAssociationRepository } from "@src/domain/repositories/masterData";
import type { CreateMasterDataRawRetailerAssociationDTO } from "@src/domain/dto/masterData";

export class CreateMasterDataRawRetailerAssociationUseCase {
  private readonly repository: IMasterDataRawRetailerAssociationRepository;

  constructor(repository: IMasterDataRawRetailerAssociationRepository) {
    this.repository = repository;
  }

  execute(params: CreateMasterDataRawRetailerAssociationDTO) {
    return this.repository.createRawAssociation(params);
  }
}
